import {
  Spinner, SpinnerSize, Typography, Icon, ICON_ALERT_CIRCLE_OUTLINE, ICON_CHECK_CIRCLE_OUTLINE,
  HStack,
  Card,
} from '@doveit/bricks';
import React from 'react';

interface FileUploadCardProps {
  fileName: string,
  error?: boolean,
  success?: boolean,
  actions?: React.ReactNode[],
  message?: string,
}

const FileUploadCard: React.FC<FileUploadCardProps> = ({
  fileName,
  error,
  success,
  actions,
  message,
}) => (
  <Card aria-label="Sezione per l'upload di file">
    <Card.Header primaryActions={actions}>
      <HStack>
        {(!error && !success) && (
          <Spinner
            size={SpinnerSize.SMALLER}
            color="neutrals.medium"
          />
        )}
        {(error || success) && (
          <Icon
            size={24}
            path={success ? ICON_CHECK_CIRCLE_OUTLINE : ICON_ALERT_CIRCLE_OUTLINE}
            color={success ? 'success.default.low' : 'critical.default.low'}
          />
        )}
        <Typography.BODY>
          <strong>
            {fileName}
          </strong>
          {message && (
            <small> - {message}</small>
          )}
        </Typography.BODY>
      </HStack>
    </Card.Header>
  </Card>
);

export default FileUploadCard;
